import React from "react";
import { overallResultData } from "./Data";

function Overall(props) {
  var overallResultText;
  var overall;
  if (props.EI >= 221 && props.EI <= 300) {
    overallResultText = overallResultData[0];
    overall = "High";
  } else if (props.EI >= 141 && props.EI <= 220) {
    overallResultText = overallResultData[1];
    overall = "Average";
  } else if (props.EI >= 60 && props.EI <= 140) {
    overallResultText = overallResultData[2];
    overall = "Below Average";
  }

  return (
    <div>
      <p>
        According to the test you’ve just taken, your scores can be interpreted
        as <strong>{overall}</strong> in overall emotional intelligence.
      </p>
      <p>{overallResultText}</p>
      <p>
        The following are the factors according to which your Emotional
        Intelligence was measured. Read ahead to find out where your strengths
        and limitations lie.
      </p>
    </div>
  );
}

export default Overall;
